// Das Inventar als Datenmodell: eine Liste von Stapeln, je Gegenstandsart höchstens einer. Die
// Leiste am unteren Bildrand ist nur eine Ansicht davon (Architektur-Regel 7).

import type { ItemId } from './items.js';

export interface ItemStack {
  item: ItemId;
  count: number;
}

export interface Inventory {
  /** Stapel in der Reihenfolge ihres ersten Auftauchens; je Art höchstens ein Eintrag. */
  stacks: ItemStack[];
}

/** Ein leeres Inventar; jeder Aufruf liefert ein eigenes Objekt. */
export function createInventory(): Inventory {
  return { stacks: [] };
}

/**
 * Legt `count` Stück (Standard 1) von `item` ins Inventar. Gleiche Arten landen auf demselben
 * Stapel. `item` wird bewusst nicht gegen ITEMS geprüft, damit Tests und spätere Arten eigene
 * Gegenstände ablegen können. Eine Anzahl, die keine positive ganze Zahl ist, ist ein Fehler.
 */
export function addItem(inv: Inventory, item: ItemId, count = 1): void {
  if (!Number.isInteger(count) || count <= 0) {
    throw new Error(`Anzahl muss eine positive ganze Zahl sein, war ${count}.`);
  }
  const stack = inv.stacks.find((s) => s.item === item);
  if (stack === undefined) {
    inv.stacks.push({ item, count });
  } else {
    stack.count += count;
  }
}

/** Wie viele Stück von `item` im Inventar liegen; 0, wenn keins. */
export function countItem(inv: Inventory, item: ItemId): number {
  let summe = 0;
  for (const stack of inv.stacks) {
    if (stack.item === item) {
      summe += stack.count;
    }
  }
  return summe;
}
